import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PwaUpdateService } from './core/services/pwa-update.service';
import { PwaService } from './core/services/pwa.service';
import { ConnectivityService } from './core/services/connectivity.service';
import { MaterialDateLocaleService } from './core/services/material-date-locale.service';
import { PwaInstallBannerComponent } from './shared/components/pwa-install-banner/pwa-install-banner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PwaInstallBannerComponent],
  template: `
    <app-pwa-install-banner />
    <router-outlet />
  `,
})
export class App implements OnInit {
  title = 'LTNG Market';
  private readonly pwaUpdate = inject(PwaUpdateService);
  readonly pwaService = inject(PwaService);
  private readonly connectivity = inject(ConnectivityService);
  private readonly materialDateLocale = inject(MaterialDateLocaleService);

  ngOnInit() {
    this.connectivity.init();
    this.pwaService.initPwaPrompt();
    this.materialDateLocale.init();
  }
}
